import { fromUnixTime } from 'date-fns';

/**
 * Gets the local Date for when a statement ID was ingested. A statementId looks like:
 * "1601575683AS0006468120193A", where the first ten digits are the Unix timestamp for the ingestion
 * time.
 * @param statementId
 */
export const getIngestionDateFromStatementId = (
    statementId: string,
): Date | null => {
    let unixTimestamp = 0;

    try {
        unixTimestamp = parseInt(statementId.slice(0, 10), 10);

        return fromUnixTime(unixTimestamp);
    } catch {
        return null;
    }
};
